import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { catchError, EMPTY, from, Observable, switchMap } from "rxjs";
import { AuthRequestService } from "./auth-request.service";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {

  private authRequestService: AuthRequestService = inject(AuthRequestService);
  private authService: AuthService = inject(AuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.authRequestService.buildHeaders(req.headers.keys().reduce((acc, key) => {
      const value = req.headers.get(key);
      if (value != null) acc[key] = value;
      return acc;
    }, {} as Record<string, string>))).pipe(
      switchMap((headers) => {
        let angularReq = req;

        headers.forEach((value, key) => {
          if (!angularReq.headers.has(key)) {
            angularReq = angularReq.clone({
              headers: angularReq.headers.set(key, value)
            });
          }
        });

        return next.handle(angularReq).pipe(
          catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
              this.handleUnauthorized(401);
              return EMPTY;
            }
            throw error;
          })
        );
      })
    );
  }

  handleUnauthorized(status: number): void {
    if (status === 401) {
      this.authService.notifySessionExpired();
    }
  }
}